// extracted by mini-css-extract-plugin
export default {"section":"ThumbnailCard_section__BMylM","list":"ThumbnailCard_list__IBLxs"};